import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const redoProducts = [
  "Returns",
  "OMS",
  "Marketing",
  "Shopper AI",
  "Checkout",
  "General",
] as const;

const featureRequestSchema = z.object({
  _id: zExt.objectId(),
  source: z.enum(["slack", "linear", "hubspot"]),
  sourceMessageId: z.string(),
  sourceUrl: z.string().optional(),
  teamId: zExt.objectId(),
  teamName: z.string().optional(),
  title: z.string(),
  description: z.string(),
  rawContent: z.string(),
  confidence: z.number(),
  product: z.enum(redoProducts).optional(),
  createdAt: z.date(),
});

const commentSchema = z.object({
  userId: z.string(),
  userEmail: z.string(),
  content: z.string(),
  createdAt: z.date(),
});

const historyEntrySchema = z.object({
  action: z.string(),
  userId: z.string(),
  userEmail: z.string(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  createdAt: z.date(),
});

const codeAnalysisSchema = z.object({
  isNewFeature: z.boolean(),
  existingLocation: z.string().nullable(),
  affectedFiles: z.array(z.string()),
  complexity: z.enum(["trivial", "small", "medium", "large", "xl"]).nullable(),
  estimatedLines: z.number().nullable(),
  correctedProduct: z.string().nullable().optional(),
  reasoning: z.string(),
});

const clusterDetailSchema = z.object({
  _id: zExt.objectId(),
  title: z.string(),
  description: z.string(),
  canonicalUserProblem: z.string(),
  product: z.enum(redoProducts).optional(),
  requestIds: z.array(zExt.objectId()),
  requestCount: z.number(),
  uniqueCompanies: z.array(z.string()),
  complexity: z.enum(["trivial", "small", "medium", "large", "xl"]).optional(),
  estimatedLines: z.number().nullable(),
  complexityReasoning: z.string().nullable(),
  priorityScore: z.number(),
  priorityReasoning: z.string().nullable(),
  status: z.enum(["pending", "approved", "rejected", "deferred", "shipped"]),
  linearTicketId: z.string().nullable(),
  linearTicketUrl: z.string().nullable(),
  codeAnalysis: codeAnalysisSchema.nullable().optional(),
  comments: z.array(commentSchema),
  history: z.array(historyEntrySchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const getClusterDetail = {
  name: "getClusterDetail" as const,
  input: z.object({ clusterId: zExt.objectId() }),
  output: z.object({
    cluster: clusterDetailSchema,
    requests: z.array(featureRequestSchema),
  }),
};
